const JOB_FIELD = {
  name: 'jobId',
  label: 'Job Title / ID',
  type: 'search-select',
  required: true,
  placeholder: 'Minimum 3 characters',
  searchFetchKey: 'tagToJobJobList',
  valueKey: '_id',
  labelTemplate: '{jobReferenceId} - {jobTitle}',
};

const HIRING_STAGE_FIELD = {
  name: 'hiringStage',
  label: 'Hiring stage',
  type: 'select',
  required: true,
  // Options come from the admin-configured action's Popup Context JSON
  // (e.g. {"hiringStageOptions": [{"label":"Shortlisted","value":"goodfited"},
  // {"label":"Pipeline","value":"pipeline"}]} — see RowActionsSection.jsx),
  // via the same generic optionsKey/defaultOptions mechanism every other
  // static-options popup field already uses (resolveOptions in popupUtils.js).
  // defaultOptions is the fallback when no action has configured its own.
  optionsKey: 'hiringStageOptions',
  defaultOptions: [
    { label: 'Shortlisted', value: 'shortlisted' },
    { label: 'Pipeline', value: 'pipeline' },
  ],
  // Lets an admin-configured action (e.g. "Shortlisted") reuse this same
  // popup pre-filled via its Popup Context JSON — e.g. {"hiringStage":
  // "goodfited"} — instead of duplicating the Tag to Job flow.
  initialValueKey: 'hiringStage',
};

export const config = {
  title: 'Tag to Job',
  okText: 'Tag',
  width: 480,
  disabledUntilFilled: true,
  // When the caller already knows both the job AND the hiring stage (e.g.
  // Source Candidates' "Shortlisted" action, which locks hiringStage via
  // popupState), there's nothing left to ask — auto-submit instead of
  // showing an empty confirm dialog. "Tag to Jobs" only locks jobId, so it
  // still shows the (now single-field) hiring-stage picker.
  autoSubmitWhenNoFields: true,
  // The job field is only shown when the caller doesn't already know the
  // job — e.g. Source Candidates' "Shortlisted"/"Tag to Jobs" actions pass
  // the currently open job via popupState.jobId (see ListView's
  // action.popupState -> location.state.popupContext -> here), so the admin
  // never has to re-search a job they're already looking at candidates for.
  getFields: (context) => {
    if (context.jobId && context.hiringStage) return [];
    return context.jobId ? [HIRING_STAGE_FIELD] : [JOB_FIELD, HIRING_STAGE_FIELD];
  },
};
